(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-launch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-launch__countdown').forEach((el) => {
    const raw = el.getAttribute('data-launch-date');
    if (!raw) return;
    const target = new Date(raw);
    if (Number.isNaN(target.getTime())) return;

    const dd = el.querySelector('[data-dd]');
    const hh = el.querySelector('[data-hh]');
    const mm = el.querySelector('[data-mm]');
    const ss = el.querySelector('[data-ss]');

    const tick = () => {
      const now = new Date();
      const diff = Math.max(0, target.getTime() - now.getTime());
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;
      if (dd) dd.textContent = String(days).padStart(2, '0');
      if (hh) hh.textContent = String(hours).padStart(2, '0');
      if (mm) mm.textContent = String(mins).padStart(2, '0');
      if (ss) ss.textContent = String(secs).padStart(2, '0');
    };

    tick();
    setInterval(tick, 1000);
  });
  // Persist UTM attribution and submit it as Shopify customer tags so it is
  // visible on the Customer record and in CSV exports.
  (() => {
    const STORAGE_KEY = 'wimmerLeadAttributionV1';
    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    const safeParse = (raw) => {
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    };

    const sanitizeTagValue = (value) =>
      String(value || '')
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 48);

    const params = new URLSearchParams(window.location.search);
    const currentTouch = {};
    let hasCurrentAttribution = false;

    UTM_KEYS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        currentTouch[key] = val;
        hasCurrentAttribution = true;
      }
    });

    if (params.get('gclid')) {
      currentTouch.gclid = params.get('gclid');
      hasCurrentAttribution = true;
    }
    if (params.get('fbclid')) {
      currentTouch.fbclid = params.get('fbclid');
      hasCurrentAttribution = true;
    }

    let stored = safeParse(window.localStorage.getItem(STORAGE_KEY)) || {};

    if (hasCurrentAttribution) {
      const touchMeta = {
        ...currentTouch,
        landing_path: window.location.pathname,
        captured_at: new Date().toISOString()
      };

      if (!stored.first_touch) {
        stored.first_touch = touchMeta;
      }
      stored.last_touch = touchMeta;

      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch (e) {
        // Ignore storage write errors (private mode / quota / browser policies)
      }
    }

    stored = safeParse(window.localStorage.getItem(STORAGE_KEY)) || stored || {};
    const attribution = stored.first_touch || stored.last_touch;
    if (!attribution) return;

    const pathTag = sanitizeTagValue(window.location.pathname.replace(/^\/+/, ''));

    document.querySelectorAll('.collection-launch__form-fields').forEach((form) => {
      const tagsField = form.querySelector('.collection-launch__tags-field');
      if (!tagsField) return;

      const tagSet = new Set(
        String(tagsField.value || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean)
      );

      if (pathTag) tagSet.add(`lead_page__${pathTag}`);

      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
        const val = sanitizeTagValue(attribution[key]);
        if (val) tagSet.add(`${key}__${val}`);
      });

      const qrCodeTag = sanitizeTagValue(attribution.utm_content || attribution.utm_source);
      if (qrCodeTag) tagSet.add(`qr_code__${qrCodeTag}`);

      if (attribution.gclid) tagSet.add('ad_click__gclid');
      if (attribution.fbclid) tagSet.add('ad_click__fbclid');

      tagsField.value = Array.from(tagSet).join(',');
    });

    const emitAnalyticsEvent = (eventName, payload) => {
      const eventPayload = {
        event: eventName,
        ...payload
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventPayload);

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }

      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(eventName, payload);
        }
      } catch (e) {
        // Ignore Shopify analytics publish errors
      }

      try {
        document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
      } catch (e) {
        // Ignore CustomEvent errors
      }
    };

    const qrCodeId = sanitizeTagValue(attribution.utm_content || attribution.utm_source);
    const basePayload = {
      page_path: window.location.pathname,
      page_url: window.location.href,
      qr_code_id: qrCodeId || '',
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
      utm_content: attribution.utm_content || '',
      utm_term: attribution.utm_term || ''
    };

    document
      .querySelectorAll('[data-wimmer-waitlist-success]')
      .forEach((marker) => {
        const phaseValue = marker.getAttribute('data-wimmer-waitlist-phase') || '';
        const signupKey = `wimmer_waitlist_signup__${window.location.pathname}__${phaseValue}`;
        let alreadySent = false;
        try {
          alreadySent = window.sessionStorage.getItem(signupKey) === '1';
        } catch (e) {}

        if (alreadySent) return;

        emitAnalyticsEvent('wimmer_waitlist_signup', {
          ...basePayload,
          form_type: 'collection_launch',
          launch_phase: phaseValue
        });

        try {
          window.sessionStorage.setItem(signupKey, '1');
        } catch (e) {}
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ligneolus-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('.ligneolus-video-hero');
    if (!hero) return;

    const stage = hero.querySelector('.ligneolus-video-hero__stage');
    const playIcon = hero.querySelector('.ligneolus-video-hero__play-icon');
    const playBtn = hero.querySelector('.ligneolus-video-hero__play-btn');
    let hideTimer;

    // Nothing autoplays, so every play() call here happens inside a direct
    // click handler, which is exactly the user gesture browsers require to
    // allow audio - no muted-autoplay workaround needed.
    const togglePlayback = () => {
      const video = hero.querySelector('video');
      if (!video || !playIcon) return;

      clearTimeout(hideTimer);
      if (video.paused) {
        video.muted = false;
        video.play().catch(() => {});
        if (playBtn) playBtn.classList.add('is-hidden');
        playIcon.textContent = '▶';
        playIcon.classList.add('is-visible');
        hideTimer = setTimeout(() => playIcon.classList.remove('is-visible'), 600);
      } else {
        video.pause();
        playIcon.textContent = '⏸';
        playIcon.classList.add('is-visible');
      }
    };

    if (playBtn) {
      playBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        togglePlayback();
      });
    }

    if (stage) {
      stage.addEventListener('click', togglePlayback);
      stage.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          togglePlayback();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'wimmerLeadAttributionV1';
    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    const safeParse = (raw) => {
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    };

    const sanitizeTagValue = (value) =>
      String(value || '')
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 48);

    const params = new URLSearchParams(window.location.search);
    const currentTouch = {};
    let hasCurrentAttribution = false;

    UTM_KEYS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        currentTouch[key] = val;
        hasCurrentAttribution = true;
      }
    });

    if (params.get('gclid')) {
      currentTouch.gclid = params.get('gclid');
      hasCurrentAttribution = true;
    }
    if (params.get('fbclid')) {
      currentTouch.fbclid = params.get('fbclid');
      hasCurrentAttribution = true;
    }

    let stored = safeParse(window.localStorage.getItem(STORAGE_KEY)) || {};

    if (hasCurrentAttribution) {
      const touchMeta = {
        ...currentTouch,
        landing_path: window.location.pathname,
        captured_at: new Date().toISOString()
      };
      if (!stored.first_touch) stored.first_touch = touchMeta;
      stored.last_touch = touchMeta;

      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch (e) {
        // Ignore storage write errors
      }
    }

    stored = safeParse(window.localStorage.getItem(STORAGE_KEY)) || stored || {};
    const attribution = stored.first_touch || stored.last_touch;
    if (!attribution) return;

    const tagsField = document.querySelector('.password-waitlist__tags-field');
    if (!tagsField) return;

    const tagSet = new Set(
      String(tagsField.value || '')
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean)
    );

    const pathTag = sanitizeTagValue(window.location.pathname.replace(/^\/+/, ''));
    if (pathTag) tagSet.add(`lead_page__${pathTag}`);

    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
      const val = sanitizeTagValue(attribution[key]);
      if (val) tagSet.add(`${key}__${val}`);
    });

    const qrCodeTag = sanitizeTagValue(attribution.utm_content || attribution.utm_source);
    if (qrCodeTag) tagSet.add(`qr_code__${qrCodeTag}`);

    if (attribution.gclid) tagSet.add('ad_click__gclid');
    if (attribution.fbclid) tagSet.add('ad_click__fbclid');

    tagsField.value = Array.from(tagSet).join(',');

    const emitAnalyticsEvent = (eventName, payload) => {
      const eventPayload = { event: eventName, ...payload };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventPayload);

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }

      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(eventName, payload);
        }
      } catch (e) {}
    };

    const successMessage = document.querySelector('.password-waitlist__message--success');
    if (!successMessage) return;

    const signupKey = `wimmer_waitlist_signup__${window.location.pathname}__password`;
    let alreadySent = false;
    try {
      alreadySent = window.sessionStorage.getItem(signupKey) === '1';
    } catch (e) {}
    if (alreadySent) return;

    emitAnalyticsEvent('wimmer_waitlist_signup', {
      page_path: window.location.pathname,
      page_url: window.location.href,
      form_type: 'password_waitlist',
      launch_phase: 'password',
      qr_code_id: qrCodeTag || '',
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
      utm_content: attribution.utm_content || '',
      utm_term: attribution.utm_term || ''
    });

    try {
      window.sessionStorage.setItem(signupKey, '1');
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qr-landing-venues-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'wimmerLeadAttributionV1';
    const VIEW_KEY_PREFIX = 'wimmer_qr_landing_view__';

    const safeParse = (raw) => {
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    };

    const sanitizeTagValue = (value) =>
      String(value || '')
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 48);

    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const params = new URLSearchParams(window.location.search);
    const currentTouch = {};
    let hasCurrentAttribution = false;

    UTM_KEYS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        currentTouch[key] = val;
        hasCurrentAttribution = true;
      }
    });
    if (params.get('gclid')) {
      currentTouch.gclid = params.get('gclid');
      hasCurrentAttribution = true;
    }
    if (params.get('fbclid')) {
      currentTouch.fbclid = params.get('fbclid');
      hasCurrentAttribution = true;
    }

    let stored = safeParse(window.localStorage.getItem(STORAGE_KEY)) || {};
    if (hasCurrentAttribution) {
      const touchMeta = {
        ...currentTouch,
        landing_path: window.location.pathname,
        captured_at: new Date().toISOString()
      };
      if (!stored.first_touch) stored.first_touch = touchMeta;
      stored.last_touch = touchMeta;
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch (e) {}
    }

    stored = safeParse(window.localStorage.getItem(STORAGE_KEY)) || stored || {};
    const attribution = stored.first_touch || stored.last_touch || {};
    const qrCodeId = sanitizeTagValue(attribution.utm_content || attribution.utm_source);

    const dedupeKey = `${VIEW_KEY_PREFIX}${window.location.pathname}__${qrCodeId || 'direct'}`;
    let alreadySent = false;
    try {
      alreadySent = window.sessionStorage.getItem(dedupeKey) === '1';
    } catch (e) {}
    if (alreadySent) return;

    const payload = {
      page_path: window.location.pathname,
      page_url: window.location.href,
      qr_code_id: qrCodeId || '',
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
      utm_content: attribution.utm_content || '',
      utm_term: attribution.utm_term || ''
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'wimmer_qr_landing_view', ...payload });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'wimmer_qr_landing_view', payload);
    }

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('wimmer_qr_landing_view', payload);
      }
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('wimmer_qr_landing_view', { detail: payload }));
    } catch (e) {}

    try {
      window.sessionStorage.setItem(dedupeKey, '1');
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();
})();
